import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Card } from '../../../card-container/card/card';
import { Student360Service } from '../../../../student360.service';
import { UserService } from '../../../../../shared-components/user/user.service';
import { Router } from '@angular/router';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { Student } from '../../../../../shared-components/student/student.model';
import { YearService } from '../../../../../shared-components/year/year.service';
import { StudentDetail } from '../../../../student-details/student-detail.model';
import { LoginService } from '../../../../../shared-modules/login/login.service';

@Component({
    selector: 'app-student-details-card',
    templateUrl: './student-details-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./student-details-card.component.css']
})
export class StudentDetailsCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    student: Student;
    studentDetails: StudentDetail;
    studentLoginHidden = true;
    studentPasswordHidden = true;
    lockerComboHidden = true;
    maskedLogin = '';
    maskedPassword = '';
    maskedLocker = '';
    enrolledSchools: string[] = [];
    v10 = true;

    constructor(
        private student360Service: Student360Service,
        private userService: UserService,
        private yearService: YearService,
        private studentService: StudentService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        this.card = this.data;
        this.v10 = this.loginService.LoginSettings.V10;
        this.student = this.studentService.selectedStudent;
        this.getStudentDetails();
    }

    ngOnDestroy(): void {
    }

    getStudentDetails() {
        this.studentService.getStudentDetails(this.student.Id, this.yearService.defaultYear.Id, this.userService.userId, true).subscribe((response) => {
            this.studentDetails = response;
            if (this.studentDetails != null) {
                if (this.studentDetails.ShowStudentLogin) {
                    this.maskedLogin = '';
                    for (let i = 0; i < this.studentDetails.StudentLogin.length; i++) {
                        this.maskedLogin = this.maskedLogin + '*';
                    }
                }
                if (this.studentDetails.ShowStudentPassword) {
                    this.maskedPassword = '';
                    for (let i = 0; i < this.studentDetails.StudentPassword.length; i++) {
                        this.maskedPassword = this.maskedPassword + '*';
                    }
                }
                if (this.studentDetails.LockerCombination != null) {
                    this.maskedLocker = '';
                    for (let i = 0; i < this.studentDetails.LockerCombination.length; i++) {
                        this.maskedLocker = this.maskedLocker + '*';
                    }
                }
                if (this.studentDetails.DualEnrolled) {
                    this.enrolledSchools = this.studentDetails.DualEnrolled.split(',');
                }
            }
            this.updateView();
        });
    }

    viewStudentDetails() {
        this.router.navigateByUrl('/student360/studentDetails?studentPortal=true');
    }

    updateView() {
        this.cdr.detectChanges();
    }

}
